import React from 'react'
import { Bell } from 'lucide-react'
import { motion } from 'framer-motion'
import { AdminNotification } from '../../../types/adminNotifications'
import AdminNotificationItem from './AdminNotificationItem'
import LoadingSpinner from '../../common/LoadingSpinner'

interface AdminNotificationDropdownProps {
  notifications: AdminNotification[]
  unreadCount: number
  isLoading: boolean
  onMarkAsRead: (id: string) => void
  onMarkAllAsRead: () => void
  onClose: () => void
}

const AdminNotificationDropdown: React.FC<AdminNotificationDropdownProps> = ({
  notifications,
  unreadCount,
  isLoading,
  onMarkAsRead,
  onMarkAllAsRead,
  onClose,
}) => {
  return (
    <>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-40"
        onClick={onClose}
      />

      <motion.div
        initial={{ opacity: 0, y: 10, scale: 0.95 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: 10, scale: 0.95 }}
        className="absolute right-0 mt-2 w-80 sm:w-96 bg-surface dark:bg-ink-700 rounded-caderno-sm shadow-caderno-lg border border-cream-400 dark:border-ink-500 z-50 max-h-[80vh] overflow-hidden"
      >
        <div className="p-3 sm:p-4 border-b border-cream-300 dark:border-ink-500">
          <div className="flex items-center justify-between gap-2">
            <h3 className="font-semibold text-ink-900 dark:text-cream-50 text-sm sm:text-base truncate">
              Atividade da Plataforma
            </h3>
            {unreadCount > 0 && (
              <button
                onClick={onMarkAllAsRead}
                className="text-xs sm:text-sm text-terra-700 dark:text-terra-300 hover:text-terra-500 dark:hover:text-terra-100 whitespace-nowrap flex-shrink-0"
              >
                Marcar todas como lidas
              </button>
            )}
          </div>
        </div>

        <div className="max-h-[calc(80vh-120px)] overflow-y-auto">
          {isLoading ? (
            <div className="p-8 text-center">
              <LoadingSpinner size="sm" text="Carregando atividades..." />
            </div>
          ) : notifications.length === 0 ? (
            <div className="p-8 text-center">
              <Bell className="w-12 h-12 text-ink-300 dark:text-ink-500 mx-auto mb-3" />
              <p className="text-ink-400 dark:text-ink-400">Nenhuma atividade recente</p>
            </div>
          ) : (
            notifications.map((notification) => (
              <AdminNotificationItem
                key={notification.id}
                notification={notification}
                onMarkAsRead={onMarkAsRead}
                onNavigate={onClose}
              />
            ))
          )}
        </div>
      </motion.div>
    </>
  )
}

export default AdminNotificationDropdown
